/**
 * Global application configuration
 * This file contains app-wide settings that can be easily toggled
 */

export const APP_CONFIG = {
    // Email verification toggle
    // When ON: Users must verify their email before signing in
    // When OFF: Users can sign in without email verification
    REQUIRE_EMAIL_VERIFICATION: true, // Set to true to enable, false to disable
    
    // Free trial configuration
    FREE_TRIAL_RUNS: 3, // Number of free runs given when user adds payment method
    FREE_TRIAL_API_KEY: process.env.REACT_APP_FREE_TRIAL_API_KEY || '', // API key for free trial users
    
    // Pricing configuration
    SUBSCRIPTION_PRICE: '6.99', // Monthly subscription price
    SUBSCRIPTION_DISCOUNT_PERCENT: '33', // Discount percentage off regular pricing
    
    UPDATE_SHOPPING_LIST_ON_SAVE: false,
    
    // Model configuration
    RECOMMENDED_REFINEMENT_MODEL: 'gemini-2-5-flash', // Recommended model for accurate macro targeting
    
    // Other app-wide settings can be added here
} as const;

// Type-safe config getter
export const getConfig = <K extends keyof typeof APP_CONFIG>(key: K): typeof APP_CONFIG[K] => {
    return APP_CONFIG[key];
}; 